/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusHistoryEnumItem
 */
export interface BonusHistoryEnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof BonusHistoryEnumItem
     */
    code?: number;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof BonusHistoryEnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the BonusHistoryEnumItem interface.
 */
export function instanceOfBonusHistoryEnumItem(value: object): value is BonusHistoryEnumItem {
    return true;
}

export function BonusHistoryEnumItemFromJSON(json: any): BonusHistoryEnumItem {
    return BonusHistoryEnumItemFromJSONTyped(json, false);
}

export function BonusHistoryEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusHistoryEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function BonusHistoryEnumItemToJSON(json: any): BonusHistoryEnumItem {
    return BonusHistoryEnumItemToJSONTyped(json, false);
}

export function BonusHistoryEnumItemToJSONTyped(value?: BonusHistoryEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

